import { SupportCategoryItem } from '@/api/placementApi.schemas';
import { AllocationAnalysis } from '@/components/AllocationAnalysis/AllocationAnalysis';
import { SummaryWalletArbitrage } from '@/components/SummaryWalletArbitrage/SummaryWalletArbitrage';

type ArbitrageSummaryRecapProps = {
  currentScore: number;
  newScore: number;
  currentProfile: string;
  newProfile: string;
  contractName: string;
  totalReinvested: number;
  totalFees: number;
  exitFees: number;
  entryFees: number;
  beforeCategories: SupportCategoryItem[] | null | undefined;
  afterCategories: SupportCategoryItem[] | null | undefined;
};

const ArbitrageSummaryRecap = ({
  currentScore,
  newScore,
  currentProfile,
  newProfile,
  contractName,
  totalReinvested,
  totalFees,
  exitFees,
  entryFees,
  beforeCategories,
  afterCategories,
}: ArbitrageSummaryRecapProps) => (
  <>
    <AllocationAnalysis
      currentScore={currentScore}
      newScore={newScore}
      currentProfile={currentProfile}
      newProfile={newProfile}
      contractName={contractName}
      totalReinvested={totalReinvested}
      totalFees={totalFees}
    />
    <div>
      <SummaryWalletArbitrage
        exitFees={exitFees}
        entryFees={entryFees}
        beforeCategories={beforeCategories}
        afterCategories={afterCategories}
      />
    </div>
  </>
);

export default ArbitrageSummaryRecap;
